import React from "react";

export default class MdTable extends React.Component {
  render = () => <table className="table">{this.props.children}</table>;
}
